import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const ITEMS = [
    "Fully Insured",
    "Council Approved",
    "Guaranteed Work",
    "Planning Handled",
    "Fast Installation",
    "Free Quotes",
];

export default function EditorialMarquee() {
    return (
        <div className="bg-amber text-tarmac border-y border-tarmac py-4 overflow-hidden" data-testid="marquee-band">
            <Marquee speed={35} gradient={false} pauseOnHover>
                {ITEMS.map((item) => (
                    <span key={item} className="flex items-center">
                        <span className="font-mono text-sm tracking-[0.25em] uppercase font-bold px-8">
                            {item}
                        </span>
                        <Star size={12} fill="currentColor" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
